module.exports = __webpack_public_path__ + "static/media/fastpath.2272b5db.png";